export default __webpack_public_path__ + "static/media/bci-7-hover.6dda5208.svg";